import React from 'react'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'

type PersonalOffersBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function PersonalOffersBlock ({
  block,
  onChange
}: PersonalOffersBlockProps) {
  return (
    <div>
      <h4>Персональные предложения</h4>
      <p>Блок отображает персонализированные предложения для пользователя. Дополнительные настройки не требуются.</p>
    </div>
  )
}